import type { SubjectSlug } from '@jeraisonne/db';

/**
 * Borne les matières proposables à l'élève dans le sélecteur de chapitre de
 * `SubmitExerciseModal` (migration 0227) : niveau ∩ matières du tuteur ∩
 * matières de l'élève, avec repli sur niveau ∩ tuteur si cette dernière
 * intersection est vide (élève sans matières à jour, ou tuteur généraliste
 * couvrant une matière que l'élève n'a pas encore cochée) — évite de
 * bloquer l'élève avec un sélecteur vide plutôt que de risquer d'envoyer
 * l'exercice au mauvais tuteur.
 *
 * `tutorSubjects`/`studentSubjects` vides = « toutes matières » (même
 * convention que `tutor_links.subjects`/`student_profiles.subjects`).
 */
export function resolveSubmissionSubjects(
  studentSubjects: SubjectSlug[],
  tutorSubjects: SubjectSlug[],
  levelSubjects: SubjectSlug[],
): SubjectSlug[] {
  const tutorScoped =
    tutorSubjects.length > 0
      ? levelSubjects.filter((s) => tutorSubjects.includes(s))
      : levelSubjects;
  if (studentSubjects.length === 0) return tutorScoped;
  const studentScoped = tutorScoped.filter((s) => studentSubjects.includes(s));
  return studentScoped.length > 0 ? studentScoped : tutorScoped;
}
